<script>
	import {onMount} from 'svelte'
	import {API,http_headers,SPINNER} from '../global.js'
	import Pago from './pago.svelte'
//	import PayRequest from './payrequest.svelte'
	import Cobranza from '../cliente/formas-pago.svelte'
	import Informe from './informe.svelte'

	export let data = {info:{IdCliente:''}}

	let idcliente = data.info.IdCliente || 0

	let loading = false
	let page=0
	let rpp=20
	let eof=false
	let buscar_cliente= idcliente
	let buscar_estado = ''
	let estados = ["PEND","OK","RECH","CUOTA1-OK","CUOTA1-RE","OK-RE"]
	let update = false
	let nuevo_estado = ''

	let buscar_moneda = ''
	let buscar_concepto = ''
	let importe_alta = ''

	let tipo_cobranza= {}
	let cobranzas = []
	let agregar_pago = false
	let cobranza = {}
	let cierres_periodos = []
	let cierre_periodo = {}

	$: refresh = async()=>{
		let res = await fetch(`${API}/cliente-pagos/${idcliente}/${update}?e=${buscar_estado}&m=${buscar_moneda}&c=${buscar_concepto}&p=${page}&rpp=${rpp}`)
		const ds = await res.json()
		return ds || []
	}

	const buscar = () => {
		cliente = buscar_cliente || 0
	}

	const actualizar = () => {
		update = !update
		//get_estados()
	}

	const guardar = async (ev) => {
		loading = true
		let params = ev.detail.item

		let rs = await fetch(`${API}/cliente-actualizar-pago/${params.id}`,{
	        method:'PUT',
	        headers: http_headers,
	        body: JSON.stringify(params)
	    })
		let ds = await rs.json()
		importe_alta = ''

		loading = false
	}

	const agregar = () => {
		cobranza = tipo_cobranza
		cobranza.idcliente = idcliente
		cobranza.importe = importe_alta
		agregar_pago = true
	}

	const close = () => {
		agregar_pago = false
		update = !update
	}

	let informe_ver = false
	const informe_abrir = () => {
		informe_ver = true
	}

	onMount( async () =>{
		loading = true
		let rs = await fetch(`${API}/w_cobranzas`)
		let ds = await rs.json()
		cobranzas = ds.data
		tipo_cobranza = cobranzas[0]

		let query = 'select top 12 * from cierres_periodos order by id desc'
		let rs2 = await fetch(`${API}/exec-query?u=false`,
			{
				method:'POST',
				headers: http_headers,
				body:JSON.stringify({query})	
			})
		let ds2 = await rs2.json()
		if(ds2.success) {
			cierres_periodos = ds2.data
			cierre_periodo = cierres_periodos[0]
		} else {
			cierres_periodos = []
			cierre_periodo = 'xxx'
		}


		//console.log(cobranzas)
		loading = false
	})

</script>

{#if !loading}

	<div class="container my-3 pb-4">

	  {#if idcliente>0}
	  	<div class="row mb-1 p-2 rounded" style="background-color:#cDcDcD;">
		    <div class="col-3">
		      	<select class="form-select" bind:value={tipo_cobranza}>
		      		{#each cobranzas as cob, index}
		      			<option value="{cob}">{cob.cobdesc}</option>
		      		{/each}
				</select>
		    </div>
		    <div class="col-3">
		    	<select class="form-select" bind:value={tipo_cobranza.simbolo}>
		    		<option value="{'$'}">$</option>
		    		<option value="{'U$s'}">U$s</option>
		    	</select>
			</div>
			<div class="col-3">
				<input class="form-control" type="text" bind:value={importe_alta} placeholder="Importe">
			</div>

		    <div class="col-3 text-center">
		    	<button on:click={agregar} class="btn btn-danger form-control text-truncate" disabled="{parseFloat(importe_alta||0)<1}">+&nbsp;Agregar</button>
		    </div>
	  	</div>
	 {/if}

	  {#if idcliente===0}
	  <!--
		<div class="btn-toolbar my-2 rounded" role="toolbar" aria-label="Toolbar" style="background-color:#eee;">
			<div class="btn-group-sm m-2" role="group" aria-label="Second group">
		-->
			{#if informe_ver }
				<Informe close={()=>informe_ver=false} periodo={cierre_periodo}/>
			{/if}			
			<div class="row mb-1 p-2 rounded" style="background-color:#eee;">
				<div class="col-4">
					<select class="form-select" bind:value={buscar_estado}>
						<option value="" disabled>Estado</option>
						<option value="">todos</option>
						{#each estados as estado}
							<option>{estado}</option>
						{/each}
					</select>
				</div>

				<div class="col-4">
					<!-- filtra complejo -->
					<select class="form-select" bind:value={buscar_moneda}>
						<option value="" disabled>Moneda</option>
						<option value="">todas</option>
						<option value=" $ ">AR$</option>
						<option value="U$s">US$</option>
					</select>
				</div>

				<div class="col-4">
					<!-- filtra forma de pago -->
					<select class="form-select" bind:value={buscar_concepto}>
						<option value="" disabled>Forma de Pago</option>
						<option value="">todas</option>
						<option value="TC">Tar. Credito</option>
						<option value="DA">Deb. Automatico</option>
						<option value="DEBDIR">Deb. Directo</option>
						<option value="TR">Transferencia</option>
					</select>
				</div>
			</div>

	  {/if}

		<div class="container">

				{#await refresh()}
					<i class="spinner"></i>
				{:then ds}

					<nav aria-label="control de paginas">
					  <ul class="pagination pagination-sm">
					    <li class="page-item" class:disabled={page===0}>
					      <a class="page-link" href="{'#'}" aria-label="Previous" on:click={()=>page=page>0?page-1:page}>
					        <span aria-hidden="true">&laquo;</span>
					      </a>
					    </li>
					    <li class="page-item"><a class="page-link" href="{ '#' }">
					    	<span aria-hidden="true">{ds.page}</a>
					    </li>
					    <li class="page-item"  class:disabled={ds.eof}>
					      <a class="page-link" href="{'#'}" aria-label="Next" on:click={()=>page=eof?page:page+1}>
					        <span aria-hidden="true">&raquo;</span>
					      </a>
					    </li>
					    <li class="page-item me-4">
					      <a class="page-link" href="{'#'}" aria-label="Next" on:click={actualizar}>
					        <span aria-hidden="true">Actualizar</span>
					      </a>
					    </li>
					    
				    	<div class="input-group input-group-sm ms-4" style="max-width:300px">
				    		<select name="" id="" class="form-select" bind:value={cierre_periodo}>
				    			{#each cierres_periodos as cp, index}
				    				<option value="{cp}">{cp.periodo}</option>
				    			{/each}
				    		</select>
				    		<a class="btn input-group-text bg-primary text-white" href="{'#'}" aria-label="" on:click={informe_abrir}>
						  		<span class="" id="inputGroup-sizing-sm">Informe</span>
				    		</a>
						</div>
					  </ul>
					    
   					    

					</nav>
<!--

					<div class="btn-group mb-2" role="group" aria-label="controles">
						<button type="button" class="btn btn-primary" on:click={()=>page=page>0?page-1:page}
								disabled="{ds.page===0}"><i class="bi-chevron-left"></i></button>
						<span class="btn btn-outline-primary">{ds.page}</span>
						<button type="button" class="btn btn-primary" on:click={()=>page=eof?page:page+1}
								disabled="{ds.eof}"><i class="bi-chevron-right"></i></button>
						<button type="button" class="btn btn-dark" on:click={actualizar}>
							<i class="bi-arrow-clockwise"></i>
						</button>
					</div>
-->
					{#each ds.data as item, index}
						<!--pre>{JSON.stringify(item,null,2)}</pre-->
						<!--PayRequest {item} on:save={guardar}/-->
						<Pago {item} on:save={guardar} />
					{/each}
					{:catch err}
					  	<p>No hay datos {err}</p>
				{/await}

		</div>

		{#if agregar_pago}
		   	<Cobranza {cobranza} on:close={close}/>
		{/if}

	</div>
{:else}
	<p>Loading....</p>
{/if}


